
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import { _province } from '../assets/js/province.js';
import { _city } from '../assets/js/citys.js';

export default {

beforeRouteEnter: (to, from, next) => {
next((vm) => {
});
},
components: {
PopupPicker,
},
mounted() {
this.getProvince();
},
activated() {
},
watch: {






},
props: {
title: {
type: String,
default: '',
},
required: {
type: Boolean,
default: false,
}
},
data() {
return {
addrArr: [],
address: [],
preCheck: [],
};
},
computed: {
},
methods: {
change(val) {
this.$emit('change', val);
},
addrChange(val) {
if (val[0] !== this.preCheck[0]) {
this.getCity(val[0]);
}
this.preCheck = val;
},
getProvince() {
const data = _province;
data.map((item) => {
item.name = item.content;
item.value = item.id;
return item;
});
this.address = [data, [{
name: '--',
value: '0',
}]];
this.getCity(data[0].id);
},
getCity(id) {
const data = _city[id];
if(data.length) {
data.map((item) => {
item.name = item.content;
item.value = item.id;
return item;
});
const arr = [this.address[0], data];
this.address = arr;
} else {
const arr = [this.address[0], [{
name: '--',
value: '0',
}]];
this.address = arr;
}
},
},
};
